import { default as qualified } from './qualified';

const scripts = {
  qualified,
};

export { scripts };
